import React, { useMemo } from "react";

import { IndexWithRouter } from "@heartfulnessinstitute/react-hfn-forms/dist/ui/CrudTemplate";
import { useSelector } from "react-redux";
import Config from "./config";
import { selectorSettings } from "../../common1/firebase-selectors/settings";

function Main() {
  const { amIAdmin, amITrainer, trainerOpts, trainersMap, behave_as, trainer } =
    useSelector(selectorSettings);
  const a = useMemo(
    () => Config(behave_as, amIAdmin, trainerOpts, trainersMap, trainer),
    [amIAdmin, trainerOpts, behave_as, trainersMap, trainer]
  );
  if (!amITrainer) {
    return <div>You do not have access to this page.</div>;
  }

  return <IndexWithRouter key={behave_as} Config={a} />;
}

export default React.memo(Main);
